import React from "react";

const AboutContainer = () => {
  return (
    <div>
      <h1>Hello from AboutContainer</h1>
    </div>
  );
};

export default AboutContainer;
